import { Button } from '@mui/material';
import { Add } from '@mui/icons-material';
import { useDashboardNavContext } from './DashboardNavContext';

const headerButtonSx = {
  color: '#95F205',
  textTransform: 'none',
  fontSize: 14,
  fontWeight: 600,
  minWidth: 'auto',
  px: 1.5,
  ml: 0.5,
  '&:hover': {
    color: '#95F205',
    bgcolor: 'rgba(149, 242, 5, 0.08)',
  },
};

const bottomButtonSx = {
  width: '100%',
  height: 40,
  borderRadius: 0,
  borderLeft: '1px solid #fff',
  fontSize: { xs: 10, sm: 12, md: 14 },
};

export default function DashboardAddAssetButton({ variant = 'bottom' }) {
  const { openAddCoin } = useDashboardNavContext();
  const isHeader = variant === 'header';

  return (
    <Button
      onClick={openAddCoin}
      startIcon={<Add sx={isHeader ? { fontSize: 18 } : { marginRight: -1 }} />}
      id="addCoinBtn"
      variant={isHeader ? 'text' : 'contained'}
      sx={isHeader ? headerButtonSx : bottomButtonSx}
    >
      {isHeader ? 'Add Asset' : 'Add'}
    </Button>
  );
}
